import { render } from "./Registrazione.vue?vue&type=template&id=70750d6e"
import script from "./Registrazione.vue?vue&type=script&lang=js"
export * from "./Registrazione.vue?vue&type=script&lang=js"
script.render = render

export default script